import { Directive } from '@angular/core';

@Directive({ selector: 'input[dsInput], textarea[dsInput]', host: { class: 'ds-input' } })
export class DsInputDirective {}

@Directive({ selector: 'select[dsSelect]', host: { class: 'ds-select' } })
export class DsSelectDirective {}

@Directive({ selector: 'input[type="checkbox"][dsCheckbox]', host: { class: 'ds-checkbox' } })
export class DsCheckboxDirective {}

@Directive({ selector: 'input[type="radio"][dsRadio]', host: { class: 'ds-radio' } })
export class DsRadioDirective {}
